/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";
import { register } from "swiper/element/bundle";
import type { SwiperProps, SwiperSlideProps } from "swiper/react";
import type { Swiper as SwiperInstance } from "swiper/types";

interface SwiperElement extends HTMLElement {
  initialize: () => void;
  swiper?: SwiperInstance;
}

interface ExtendedSwiperProps extends SwiperProps {
  children: React.ReactNode;
  onSwiper?: (swiper: SwiperInstance) => void;
}

export function Swiper(props: ExtendedSwiperProps) {
  const swiperRef = useRef<SwiperElement | null>(null);
  const { children, onSwiper, ...rest } = props;

  useEffect(() => {
    // Register Swiper web component
    register();

    // Ensure swiperRef.current is not null
    if (swiperRef.current) {
      // pass component props to parameters
      const params = {
        ...rest,
      };

      // Assign it to swiper element
      Object.assign(swiperRef.current, params);

      // initialize swiper
      swiperRef.current.initialize();

      const swiper = swiperRef.current.swiper;
      if (swiper && typeof onSwiper === "function") {
        onSwiper(swiper);
      }
    }
  }, []);

  return (
    <swiper-container init={false} ref={swiperRef}>
      {children}
    </swiper-container>
  );
}

export function SwiperSlide(
  props: SwiperSlideProps & { children: React.ReactNode }
) {
  const { children, ...rest } = props;

  return <swiper-slide {...rest}>{children}</swiper-slide>;
}